import {
  APIListValuesRequest,
  APIListValuesResponse,
  getFetcher,
} from "shared/api/api";
import client from "shared/api/axios";
import { createURL } from "shared/api/utils";

const listPartsValuesRequestURI = ({
  fieldName,
  ...params
}: APIListValuesRequest): string =>
  client.getUri({
    method: "get",
    url: createURL(["parts", "values", fieldName]),
    params,
  });

export const listPartsValues = (args: APIListValuesRequest) =>
  getFetcher<APIListValuesResponse>(listPartsValuesRequestURI(args));
